import { articlesClientApi } from 'api/client';
import { Api } from 'api/znaniya-client';
import React, { ChangeEvent, useEffect, useState } from 'react';
import useDebounce from 'shared/hooks/useDebounce';
import DisciplineCarousel from 'widgets/DisciplineCarousel/DisciplineCarousel';
import Footer from 'widgets/Footer/Footer';
import Header from 'widgets/Header/Header';
import SearchInput from 'widgets/SearchInput/SearchInput';
import styles from './search.module.css';
import SearchArticlesList from 'shared/components/SearchArticlesList/SearchArticlesList';
import PopularArticles from 'widgets/PopularArticles/PopularArticles';
import Head from 'next/head';

export const getServerSideProps = () => {
  return { props: {} };
};

const Index = () => {
  const [inputValue, setInputValue] = useState('');
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };
  const [disciplines, setDisciplines] = useState<string[] | []>([]);
  const [searchResults, setSearchResults] = useState<
    Api.GetArticleBySearch200Response.Article[] | []
  >([]);
  const debouncedSearchTerm = useDebounce(inputValue, 300);

  const request = async () => {
    const searchResult = await articlesClientApi.getArticleBySearch(
      debouncedSearchTerm,
      '16',
      '1',
    );

    return searchResult;
  };

  useEffect(() => {
    if (debouncedSearchTerm && debouncedSearchTerm.length > 2) {
      request().then((resp) => {
        setSearchResults(resp.articles);
        setDisciplines(resp.meta.disciplines);
      });
    }
  }, [debouncedSearchTerm]);

  const [choosedDiscipline, setChoosedDiscipline] = useState<string>('all');

  return (
    <>
      <Head>
        <title>Поиск по сервису Учи.Знания</title>
      </Head>
      <div className={styles.header}>
        <Header />
        <SearchInput inputValue={inputValue} handleInputChange={handleInputChange} />
      </div>
      {disciplines.length > 0 && debouncedSearchTerm.length > 2 && (
        <DisciplineCarousel
          choosedDiscipline={choosedDiscipline}
          setChoosedDiscipline={setChoosedDiscipline}
          disciplines={['all', ...disciplines]}
        />
      )}
      <div className={styles.results}>
        {debouncedSearchTerm.length === 0 ? (
          <PopularArticles />
        ) : searchResults.length === 0 ? (
          <p className={styles.nothing_found}>По вашему запросу ничего не найдено</p>
        ) : (
          <SearchArticlesList
            articles={searchResults}
            filterByDiscipline={choosedDiscipline}
          />
        )}
      </div>
      <Footer />
    </>
  );
};

export default Index;
